// extracted by mini-css-extract-plugin
module.exports = {"rtl":"index_rtl_2x2bc","mobileMenu":"index_mobileMenu_3DQNN","handler":"index_handler_3d1jz","handlerIcon":"index_handlerIcon_eT4k6"};